module.exports = __webpack_public_path__ + "static/3-26332ca2a45ccc842b8e58e80a8a3c4b.png";